module.exports = __webpack_public_path__ + "img/c2.7e590f0f.png";